import CreatePatientView from "../../../../Recipe/PatientAgenda/Views/CreatePatientView";

export default function CreatePatientForStudyOrderWrapper({
  selectedPatient,
  setSelectedPatient,
  returnToStudyOrder
}) {
  return (
    <CreatePatientView // Cuando se crea un paciente desde una orden de estudio, lo que hace es sobrescribir el paciente seleccionado en la orden de estudio y volver a la orden, pasando returnoToStudyOrder como onBack y onBackFromEdit en vez de ir a la agenda, es un comportamiento que intercepta el CreatePatientView y sobreescribe.
      selectedPatient={selectedPatient}
      setSelectedPatient={(p) => {
        setSelectedPatient(p);
        returnToStudyOrder();
      }}
      onBack={() => returnToStudyOrder()}
      onBackFromEdit={() => returnToStudyOrder()}

      setActiveView={() => {}}
      subActiveView={undefined}
      setSubActiveView={() => {}}
      prevActiveView={undefined}
      setPrevActiveView={() => {}}
      prevSubActiveView={undefined}
      setPrevSubActiveView={() => {}}
    />
  );
}